import {
  NAV_ITEM_TYPE_TITLE,
  NAV_ITEM_TYPE_ITEM,
  NAV_ITEM_TYPE_COLLAPSE,
} from "@/constants/navigation.constant";

import type { NavigationTree } from "@/@types/navigation";

const navigationConfig: NavigationTree[] = [
  {
    key: "home",
    path: "/admin/home",
    title: "Home",
    translateKey: "nav.home",
    icon: "home",
    type: NAV_ITEM_TYPE_ITEM,
    authority: [],
    subMenu: [],
  },

  {
    key: "assets",
    path: "/admin/assets",
    title: "Assets",
    translateKey: "nav.calendar",
    icon: "products",
    type: NAV_ITEM_TYPE_COLLAPSE,
    authority: ["ADMIN"],
    subMenu: [
      {
        key: "assets.list",
        path: "/admin/assets",
        title: "List",
        translateKey: "",
        icon: "",
        type: NAV_ITEM_TYPE_ITEM,
        authority: [],
        subMenu: [],
      },
      {
        key: "assets.import",
        path: "/admin/assets/import",
        title: "Import history",
        translateKey: "",
        icon: "",
        type: NAV_ITEM_TYPE_ITEM,
        authority: [],
        subMenu: [],
      },
    ],
  },


  {
    key: "filemanager2",
    path: "/admin/filemanager2",
    title: "File Manager",
    translateKey: "filemanager",
    icon: "folders",
    type: NAV_ITEM_TYPE_ITEM,
    authority: ["ROLE_ADMINAREA_ADMIN"],
    subMenu: [],
  },

  {
    key: "communication",
    path: "/admin/communication",
    title: "Communication",
    translateKey: "communication",
    icon: "communication",
    type: NAV_ITEM_TYPE_COLLAPSE,
    authority: [],
    subMenu: [
      {
        key: "communication.end_users",
        path: "/admin/communication/customers",
        title: "Customers",
        translateKey: "",
        icon: "support",
        type: NAV_ITEM_TYPE_ITEM,
        authority: [],
        subMenu: [],
      },
      {
        key: "communication.support",
        path: "/admin/communication/support",
        title: "Support Hub",
        translateKey: "",
        icon: "support",
        type: NAV_ITEM_TYPE_ITEM,
        authority: [],
        subMenu: [],
      },
      /*{
        key: "communication.spare-parts",
        path: "/court-pricing",
        title: "Spare parts",
        translateKey: "",
        icon: "priceplans",
        type: NAV_ITEM_TYPE_ITEM,
        authority: [],
        subMenu: [],
      },
      {
        key: "communication.priceplans",
        path: "/priceplans",
        title: "Service",
        translateKey: "",
        icon: "priceplans",
        type: NAV_ITEM_TYPE_ITEM,
        authority: [],
        subMenu: [],
      },*/
    ],
  },

  {
    key: "pricing-collapseMenu",
    path: "",
    title: "Settings",
    translateKey: "settings",
    icon: "settings",
    type: NAV_ITEM_TYPE_COLLAPSE,
    authority: [],
    subMenu: [
      {
        key: "settings.users",
        path: "/admin/settings/users",
        title: "Users",
        translateKey: "nav.user",
        icon: "customers",
        type: NAV_ITEM_TYPE_ITEM,
        authority: [],
        subMenu: [],
      },
      {
        key: "settings.assets",
        path: "/admin/settings/assets",
        title: "Asset Frontend",
        translateKey: "nav.asset_components",
        icon: "assets",
        type: NAV_ITEM_TYPE_ITEM,
        authority: [],
        subMenu: [],
      },
      /* Hidden - the routes still exist, only the menu entry is gone.
      {
        key: "settings.inte",
        path: "/admin/settings/web_inte",
        title: "Web Integration",
        translateKey: "nav.web.inte",
        icon: "asset_components",
        type: NAV_ITEM_TYPE_ITEM,
        authority: [],
        subMenu: [],
      },*/
      {
        key: "settings.look_and_feel",
        path: "/admin/settings/look_and_feel",
        title: "Look And Feel",
        translateKey: "nav.look_and_feel",
        icon: "asset_components",
        type: NAV_ITEM_TYPE_ITEM,
        authority: [],
        subMenu: [],
      },
     /* {
        key: "settings.language",
        path: "/admin/settings/language",
        title: "Language",
        translateKey: "nav.language",
        icon: "asset_components",
        type: NAV_ITEM_TYPE_ITEM,
        authority: [],
        subMenu: [],
      },*/
    ],
  },

  /** Example purpose only, please remove
   {
   key: 'singleMenuItem',
   path: '/single-menu-view',
   title: '-',
   translateKey: 'nav.singleMenuItem',
   icon: 'singleMenu',
   type: NAV_ITEM_TYPE_ITEM,
   authority: [],
   subMenu: [],
   },
   {
   key: 'collapseMenu',
   path: '',
   title: '-',
   translateKey: 'nav.collapseMenu.collapseMenu',
   icon: 'collapseMenu',
   type: NAV_ITEM_TYPE_COLLAPSE,
   authority: [],
   subMenu: [
   {
   key: 'collapseMenu.item1',
   path: '/collapse-menu-item-view-1',
   title: 'Collapse menu item 1',
   translateKey: 'nav.collapseMenu.item1',
   icon: '',
   type: NAV_ITEM_TYPE_ITEM,
   authority: [],
   subMenu: [],
   },
   {
   key: 'collapseMenu.item2',
   path: '/collapse-menu-item-view-2',
   title: 'Collapse menu item 2',
   translateKey: 'nav.collapseMenu.item2',
   icon: '',
   type: NAV_ITEM_TYPE_ITEM,
   authority: [],
   subMenu: [],
   },
   ],
   },
   {
   key: 'groupMenu',
   path: '',
   title: '_-_',
   translateKey: 'nav.groupMenu.groupMenu',
   icon: 'groupMenu',
   type: NAV_ITEM_TYPE_TITLE,
   authority: [],
   subMenu: [
   {
   key: 'groupMenu.single',
   path: '/group-single-menu-item-view',
   title: '---',
   translateKey: 'nav.groupMenu.single',
   icon: 'groupSingleMenu',
   type: NAV_ITEM_TYPE_ITEM,
   authority: [],
   subMenu: [],
   },
   {
   key: 'groupMenu.collapse',
   path: '/asldaldklaksdlasda',
   title: '----',
   translateKey: 'nav.groupMenu.collapse.collapse',
   icon: 'groupCollapseMenu',
   type: NAV_ITEM_TYPE_COLLAPSE,
   authority: [],
   subMenu: [
   {
   key: 'groupMenu.collapse.item1',
   path: '/group-collapse-menu-item-view-1',
   title: 'Menu item 1',
   translateKey: 'nav.groupMenu.collapse.item1',
   icon: '',
   type: NAV_ITEM_TYPE_ITEM,
   authority: [],
   subMenu: [],
   },
   {
   key: 'groupMenu.collapse.item2',
   path: '/group-collapse-menu-item-view-2',
   title: 'Menu item 2',
   translateKey: 'nav.groupMenu.collapse.item2',
   icon: '',
   type: NAV_ITEM_TYPE_ITEM,
   authority: [],
   subMenu: [],
   },
   ],
   },
   ],
   },*/
];

export default navigationConfig;
